import React from "react";
import {
  Typography,
  Stack,
  Spacer,
  Box,
  Divider,
  useToast,
} from "digiwash-components";
import ServicesCounterChips from "../ServicesCounterChips";
import { formatNumber, formatPrice } from "digiwash-core";
import {
  FormattedCartItem,
  CartRetrieveOutput,
} from "../../ducks/cart/cart-types";
import NotifyBox from "../NotifyBox";
import CustomIcon from "../CustomIcon";
import Variation from "../Variation";
import { useUpdateCartItem } from "../../hooks/useUpdateCartItem";
import { quantityByServiceAndVariation } from "../../ducks/cart/cart-helpers";
import useCart from "../../ducks/cart/hooks/useCart";
import { useDebouncedCallback } from "use-debounce";

function CartItem(props: { data: FormattedCartItem; readonly?: boolean }) {
  let toast = useToast();
  let { addItem, removeItem } = useUpdateCartItem();
  let { retrieve: retrieveCart, revalidateCart, coupon } = useCart();
  let cart: CartRetrieveOutput = retrieveCart({ force: true });

  const debouncedHandlerForServiceClick = useDebouncedCallback(() => {
    coupon.remove().then(() => revalidateCart());

    revalidateCart().then(() => {
      coupon
        .add(coupon.code)
        .then(() => revalidateCart())
        .catch(() => {
          toast.show("مشکلی در افزودن کد تخفیف پیش آمده است.", {
            data: { type: "danger" },
          });
        });
    });
  }, 555);
  return (
    <Box br="xm" px="l" pt="l" bg="primary.light920">
      <Stack distribution="space-between">
        <Stack style={{ flex: 1 }}>
          <Typography color="common.black" numberOfLines={1}>
            {props.data.name}
          </Typography>
        </Stack>
        {props.data.total_price > 0 ? (
          <Stack>
            <Typography fs="s" color="gray.dark200">
              در مجموع:
            </Typography>
            <Spacer size="s" />
            <Typography ff="mainBold" fs="s" color="gray.dark200">
              {formatPrice(props.data.total_price)} تومان
            </Typography>
          </Stack>
        ) : (
          <Typography ff="mainBold" fs="s" color="gray.dark200">
            نیاز به کارشناسی
          </Typography>
        )}
      </Stack>
      {props.readonly ? null : (
        <>
          <Divider size="l" />
          {props.data?.variations.map((item: any) => {
            return (
              <React.Fragment key={item.id}>
                <Box bg="common.white" p="l" br="xm">
                  <Stack distribution="space-between">
                    <Stack>
                      <CustomIcon icon={item.alias} width={32} height={32} />
                      <Spacer size="l" />
                      <Box>
                        <Typography fs="xm">{item.name}</Typography>
                        <Typography ff="mainBold" fs="xm">
                          {item.price > 0
                            ? `${formatPrice(item.price)} تومان`
                            : "نیاز به کارشناسی"}
                        </Typography>
                      </Box>
                    </Stack>
                    <Variation
                      quantity={quantityByServiceAndVariation({
                        cart: cart.data,
                        service: props.data?.service_id,
                        variation: item.id,
                      })}
                      onSelectPlus={() => {
                        addItem({
                          service: props.data?.service_id,
                          variation: item.id,
                        }).then(() => {
                          revalidateCart();
                        });
                      }}
                      onSelectMinus={() => {
                        removeItem({
                          service: props.data?.service_id,
                          variation: item.id,
                        }).then(() => {
                          if (coupon.code) {
                            debouncedHandlerForServiceClick();
                          } else {
                            revalidateCart();
                          }
                        });
                      }}
                      cartMode
                    />
                  </Stack>
                </Box>
                <Divider size="l" />
              </React.Fragment>
            );
          })}
        </>
      )}

      <Divider size="l" />
      <Stack style={{ flexWrap: "wrap" }}>
        {props.data.variations.map((variation, index) => {
          return (
            <React.Fragment key={index}>
              <ServicesCounterChips {...variation} />
              <Spacer size="m" />
            </React.Fragment>
          );
        })}
      </Stack>
      {props.data.discount.quantity > 0 ? (
        <>
          <NotifyBox
            text={`${formatNumber(
              props.data.discount.quantity
            )} قلم شامل تخفیف`}
            sub={props.data.discount.quantity > 1 ? "در مجموع:" : undefined}
            total={props.data.discount.total_discount}
          />
          <Divider size="l" />
        </>
      ) : null}
    </Box>
  );
}

export default CartItem;
